export default "__VITE_ASSET__DYHx_0lS__"